import { render, staticRenderFns } from "./QuestionDetails.vue?vue&type=template&id=00040564&scoped=true&"
import script from "./QuestionDetails.vue?vue&type=script&lang=ts&"
export * from "./QuestionDetails.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionDetails.vue?vue&type=style&index=0&id=00040564&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00040564",
  null
  
)

export default component.exports